import { FIELD__base } from '../_fields/_base/FIELD__base';
import { INVOCATION__base } from '../_invocations/_base/INVOCATION__base';

export class DTO_GRAPH__edge_autoconnect_info<T_invocation extends INVOCATION__base> {
  /*
   * FIELDS
   */
  field_this!: FIELD__base;

  field_other_names!: (keyof T_invocation)[];

  /*
   * METHODS
   */
  constructor() {
    this.field_other_names = [];
  }
}
